import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) {}

  get(clientId: number) {
    return this.http.get(`${environment.url}/clients/${clientId}`) as Observable<
      any
    >;
  }

  patch(req: any, clientId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    }); 
    return this.http.patch(
      `${environment.url}/clients/${clientId}`,
      req,
      { headers: headers }
    ) as Observable<any>;
  }
}
